import { Component, ChangeDetectionStrategy, Output, Input, EventEmitter } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-sidebar-item-display-toggle',
    templateUrl: './sidebar-item-display-toggle.component.html',
    styleUrls: ['./sidebar-item-display-toggle.component.scss'],
    standalone: false,
})
export class SidebarItemDisplayToggleComponent {
    @Input()
    public display?: boolean;

    @Output()
    public readonly displayChange = new EventEmitter<boolean>();

    public setListActive(): void {
        this.display = true;
        this.displayChange.emit(true);
    }

    public setGridActive(): void {
        this.display = false;
        this.displayChange.emit(false);
    }
}
